import React from 'react';
import { Link } from 'react-router-dom';
import { FaUtensils, FaArrowDown, FaArrowRight, FaStar, FaStarHalfAlt, FaRegStar, FaCheckCircle, FaHandHoldingHeart, FaBreadSlice, FaPaperPlane, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaInstagram, FaTelegramPlane, FaYoutube, FaWhatsapp, FaFacebook } from 'react-icons/fa';

const heroBg = {
  backgroundImage:
    "linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url('https://images.unsplash.com/photo-1603360946369-dc9bb6258143?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80')",
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};

const FoodGuide: React.FC = () => (
  <div className="font-sans bg-gray-50" dir="ltr">
    {/* Navigation */}
    <nav className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between">
          <div className="flex space-x-7">
            <div>
              <a href="#" className="flex items-center py-4 px-2">
                <FaUtensils className="text-amber-600 text-2xl mr-2" />
                <span className="font-semibold text-gray-900 text-lg">Persian Flavors</span>
              </a>
            </div>
          </div>
          <div className="hidden md:flex items-center space-x-1">
            <a href="#" className="py-4 px-2 text-amber-600 border-b-4 border-amber-600 font-medium">Home</a>
            <a href="#dishes" className="py-4 px-2 text-gray-500 font-medium hover:text-amber-600 transition">Dishes</a>
            <a href="#ordering" className="py-4 px-2 text-gray-500 font-medium hover:text-amber-600 transition">Ordering</a>
            <a href="#customs" className="py-4 px-2 text-gray-500 font-medium hover:text-amber-600 transition">Customs</a>
            <a href="#contact" className="py-4 px-2 text-gray-500 font-medium hover:text-amber-600 transition">Contact</a>
          </div>
          <div className="md:hidden flex items-center">
            <button className="outline-none">
              <FaUtensils className="text-gray-500 text-xl" />
            </button>
          </div>
        </div>
      </div>
    </nav>

    {/* Hero Section */}
    <div className="relative h-96 md:h-screen flex items-center justify-center" style={heroBg}>
      <div className="text-center px-4 z-10">
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">Persian Culinary Journey</h1>
        <p className="text-xl md:text-2xl text-white mb-8">Discover the rich flavors and traditions of Iranian cuisine</p>
        <a href="#dishes" className="bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-6 rounded-full transition duration-300 inline-block">
          Explore Dishes <FaArrowDown className="inline ml-2" />
        </a>
      </div>
      {/* SVG Shape Divider */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none rotate-180">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="w-full h-32">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#fff" />
        </svg>
      </div>
    </div>

    {/* Famous Dishes Section */}
    <section id="dishes" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Popular Persian Dishes</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Dish 1 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-md transition duration-500 ease-in-out hover:-translate-y-2 hover:shadow-xl">
            <img src="https://images.unsplash.com/photo-1601050690597-df0568f70950?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Chelo Kabab" className="w-full h-64 object-cover" />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-2">Chelo Kabab</h3>
              <p className="text-gray-600 mb-4">Iran's national dish featuring juicy grilled kebabs served with saffron-infused basmati rice.</p>
              <div className="flex items-center text-amber-500">
                <FaStar /><FaStar /><FaStar /><FaStar /><FaStarHalfAlt />
                <span className="text-gray-600 ml-2">4.7</span>
              </div>
            </div>
          </div>
          {/* Dish 2 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-md transition duration-500 ease-in-out hover:-translate-y-2 hover:shadow-xl">
            <img src="https://images.unsplash.com/photo-1604977042-6f4d6fb1a9b1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Fesenjan" className="w-full h-64 object-cover" />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-2">Fesenjan</h3>
              <p className="text-gray-600 mb-4">A rich stew of duck or chicken with ground walnuts and pomegranate paste, creating a perfect balance of sweet and sour.</p>
              <div className="flex items-center text-amber-500">
                <FaStar /><FaStar /><FaStar /><FaStar /><FaRegStar />
                <span className="text-gray-600 ml-2">4.2</span>
              </div>
            </div>
          </div>
          {/* Dish 3 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-md transition duration-500 ease-in-out hover:-translate-y-2 hover:shadow-xl">
            <img src="https://images.unsplash.com/photo-1604977042-6f4d6fb1a9b1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Ghormeh Sabzi" className="w-full h-64 object-cover" />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-2">Ghormeh Sabzi</h3>
              <p className="text-gray-600 mb-4">The "king of Persian stews" made with herbs, kidney beans, and tender chunks of meat, slow-cooked to perfection.</p>
              <div className="flex items-center text-amber-500">
                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                <span className="text-gray-600 ml-2">4.9</span>
              </div>
            </div>
          </div>
          {/* Dish 4 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-md transition duration-500 ease-in-out hover:-translate-y-2 hover:shadow-xl">
            <img src="https://images.unsplash.com/photo-1601050690597-df0568f70950?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Tahchin" className="w-full h-64 object-cover" />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-2">Tahchin</h3>
              <p className="text-gray-600 mb-4">A spectacular layered saffron rice cake with chicken, yogurt, and barberries, often served at special occasions.</p>
              <div className="flex items-center text-amber-500">
                <FaStar /><FaStar /><FaStar /><FaStar /><FaStarHalfAlt />
                <span className="text-gray-600 ml-2">4.6</span>
              </div>
            </div>
          </div>
          {/* Dish 5 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-md transition duration-500 ease-in-out hover:-translate-y-2 hover:shadow-xl">
            <img src="https://images.unsplash.com/photo-1604977042-6f4d6fb1a9b1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Ash Reshteh" className="w-full h-64 object-cover" />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-2">Ash Reshteh</h3>
              <p className="text-gray-600 mb-4">A hearty noodle soup with beans, herbs, and kashk (whey), perfect for cold winter days.</p>
              <div className="flex items-center text-amber-500">
                <FaStar /><FaStar /><FaStar /><FaStar /><FaRegStar />
                <span className="text-gray-600 ml-2">4.3</span>
              </div>
            </div>
          </div>
          {/* Dish 6 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-md transition duration-500 ease-in-out hover:-translate-y-2 hover:shadow-xl">
            <img src="https://images.unsplash.com/photo-1601050690597-df0568f70950?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Zereshk Polo" className="w-full h-64 object-cover" />
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-2">Zereshk Polo</h3>
              <p className="text-gray-600 mb-4">Saffron rice with barberries and tender chicken, a beautiful and flavorful dish for celebrations.</p>
              <div className="flex items-center text-amber-500">
                <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                <span className="text-gray-600 ml-2">4.8</span>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center mt-12">
          <Link to="/cultural/recipes" className="inline-block px-6 py-3 bg-amber-600 text-white font-medium rounded-full hover:bg-amber-700 transition duration-300">
            View All Recipes & More Dishes <FaArrowRight className="inline ml-2" />
          </Link>
        </div>
      </div>
    </section>

    {/* How to Order Section */}
    <section id="ordering" className="py-16 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">How to Order Food in Iran</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Step 1 */}
          <div className="bg-white p-6 rounded-lg shadow-md text-center">
            <div className="bg-amber-100 w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
              <span className="text-amber-600 text-2xl font-bold">1</span>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Choose Your Platform</h3>
            <p className="text-gray-600">Use popular apps like SnappFood, ZoodFood, or Digikala Food. Many restaurants also have direct ordering through their websites.</p>
          </div>
          {/* Step 2 */}
          <div className="bg-white p-6 rounded-lg shadow-md text-center">
            <div className="bg-amber-100 w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
              <span className="text-amber-600 text-2xl font-bold">2</span>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Select Your Meal</h3>
            <p className="text-gray-600">Browse through hundreds of options from traditional Persian to international cuisine. Don't forget to check the daily specials!</p>
          </div>
          {/* Step 3 */}
          <div className="bg-white p-6 rounded-lg shadow-md text-center">
            <div className="bg-amber-100 w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
              <span className="text-amber-600 text-2xl font-bold">3</span>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Payment & Delivery</h3>
            <p className="text-gray-600">Pay online or cash on delivery. Delivery times average 30-45 minutes in cities. Many places offer free delivery for orders over 200,000 IRR.</p>
          </div>
        </div>
        <div className="mt-12 bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="md:flex">
            <div className="md:w-1/2 p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Pro Tips for Ordering</h3>
              <ul className="space-y-4">
                <li className="flex items-start"><FaCheckCircle className="text-amber-600 mt-1 mr-3" /><span className="text-gray-700">Lunch is typically served from 12-3pm, dinner from 7-11pm</span></li>
                <li className="flex items-start"><FaCheckCircle className="text-amber-600 mt-1 mr-3" /><span className="text-gray-700">Traditional restaurants often have better prices than international chains</span></li>
                <li className="flex items-start"><FaCheckCircle className="text-amber-600 mt-1 mr-3" /><span className="text-gray-700">Ask for "tahdig" (crispy rice) - it's often not listed on menus</span></li>
                <li className="flex items-start"><FaCheckCircle className="text-amber-600 mt-1 mr-3" /><span className="text-gray-700">Many places offer "nazri" (charity food) during religious months</span></li>
              </ul>
            </div>
            <div className="md:w-1/2">
              <img src="https://images.unsplash.com/photo-1601050690597-df0568f70950?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Persian Food Delivery" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Dining Customs Section */}
    <section id="customs" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Iranian Dining Customs</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <img src="https://images.unsplash.com/photo-1604977042-6f4d6fb1a9b1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="Persian Dining Table" className="rounded-lg shadow-lg w-full" />
          </div>
          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4">The Art of Persian Hospitality</h3>
            <p className="text-gray-600 mb-4">Iranian meals are more than just eating - they're social events that can last for hours. Guests are treated with utmost respect and generosity.</p>
            <div className="space-y-4">
              <div className="flex items-start">
                <FaHandHoldingHeart className="text-amber-600 mt-1 mr-3" />
                <div>
                  <h4 className="font-semibold text-gray-800">Taarof (Persian Politeness)</h4>
                  <p className="text-gray-600">Hosts may insist you take more food even when you're full. It's customary to politely refuse once or twice before accepting.</p>
                </div>
              </div>
              <div className="flex items-start">
                <FaUtensils className="text-amber-600 mt-1 mr-3" />
                <div>
                  <h4 className="font-semibold text-gray-800">Sofreh (Dining Spread)</h4>
                  <p className="text-gray-600">Food is traditionally served on a cloth spread on the floor with everyone sitting around it. Modern restaurants use tables.</p>
                </div>
              </div>
              <div className="flex items-start">
                <FaBreadSlice className="text-amber-600 mt-1 mr-3" />
                <div>
                  <h4 className="font-semibold text-gray-800">Bread Etiquette</h4>
                  <p className="text-gray-600">Never place bread upside down. It's considered disrespectful to the blessing of food.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 bg-amber-50 rounded-lg p-8">
          <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Essential Persian Dining Phrases</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white p-4 rounded-lg shadow-sm">
              <p className="text-gray-800 font-medium mb-2">"Nooshe jan" (نوش جان)</p>
              <p className="text-gray-600">Said before eating, meaning "May it nourish your soul"</p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm">
              <p className="text-gray-800 font-medium mb-2">"Daste shoma dard nakone" (دست شما درد نکنه)</p>
              <p className="text-gray-600">Thanking the cook ("May your hand not hurt")</p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-sm">
              <p className="text-gray-800 font-medium mb-2">"Ghaza khili khoshmaze bood" (غذا خیلی خوشمزه بود)</p>
              <p className="text-gray-600">"The food was very delicious"</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Newsletter Section */}
    <section className="py-16 bg-amber-600 text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-4 text-white">Hungry for More Persian Flavors?</h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto">Subscribe to our newsletter for weekly Persian recipes, restaurant reviews, and culinary insights from Iran.</p>
        <form className="max-w-md mx-auto">
          <div className="flex flex-col sm:flex-row gap-2">
            <input type="email" placeholder="Your email address" className="flex-grow px-4 py-3 rounded-full focus:outline-none text-gray-800" />
            <button type="submit" className="bg-gray-800 hover:bg-gray-900 px-6 py-3 rounded-full font-medium transition duration-300">
              Subscribe <FaPaperPlane className="inline ml-2" />
            </button>
          </div>
        </form>
        <p className="mt-4 text-amber-100">We respect your privacy. Unsubscribe at any time.</p>
      </div>
    </section>

    {/* Contact Section */}
    <section id="contact" className="py-16 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Have Questions About Persian Food?</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white p-8 rounded-lg shadow-md">
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Send Us a Message</h3>
            <form>
              <div className="mb-4">
                <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Your Name</label>
                <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500" />
              </div>
              <div className="mb-4">
                <label htmlFor="email" className="block text-gray-700 font-medium mb-2">Email Address</label>
                <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500" />
              </div>
              <div className="mb-4">
                <label htmlFor="message" className="block text-gray-700 font-medium mb-2">Your Question</label>
                <textarea id="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500"></textarea>
              </div>
              <button type="submit" className="bg-amber-600 hover:bg-amber-700 text-white font-medium py-3 px-6 rounded-full transition duration-300">
                Send Message <FaPaperPlane className="inline ml-2" />
              </button>
            </form>
          </div>
          <div>
            <div className="bg-white p-8 rounded-lg shadow-md mb-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Contact Information</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <FaMapMarkerAlt className="text-amber-600 mt-1 mr-3" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Address</h4>
                    <p className="text-gray-600">25152 Mawson Dr Laguna Hill CA 92653</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <FaPhoneAlt className="text-amber-600 mt-1 mr-3" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Phone</h4>
                    <a href="tel:+14245378243" className="text-gray-600 hover:text-amber-600 transition">+1 (424) 537-8243</a>
                  </div>
                </div>
                <div className="flex items-start">
                  <FaEnvelope className="text-amber-600 mt-1 mr-3" />
                  <div>
                    <h4 className="font-semibold text-gray-800">Email</h4>
                    <a href="mailto:support@pingquack.com" className="text-gray-600 hover:text-amber-600 transition">support@pingquack.com</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Follow Us</h3>
              <p className="text-gray-600 mb-6">Join our community of Persian food lovers</p>
              <div className="flex space-x-4">
                <a href="https://facebook.com/Piroozapp" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center hover:bg-blue-700 transition duration-300"><FaFacebook /></a>
                <a href="https://instagram.com/Piroozapp" target="_blank" rel="noopener noreferrer" className="bg-pink-600 text-white w-10 h-10 rounded-full flex items-center justify-center hover:bg-pink-700 transition duration-300"><FaInstagram /></a>
                <a href="https://t.me/vajakapp" target="_blank" rel="noopener noreferrer" className="bg-blue-400 text-white w-10 h-10 rounded-full flex items-center justify-center hover:bg-blue-500 transition duration-300"><FaTelegramPlane /></a>
                <a href="https://youtube.com/Piroozapp" target="_blank" rel="noopener noreferrer" className="bg-red-600 text-white w-10 h-10 rounded-full flex items-center justify-center hover:bg-red-700 transition duration-300"><FaYoutube /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Footer */}
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Persian Flavors</h3>
            <p className="text-gray-400">Exploring the rich culinary heritage of Iran, one dish at a time.</p>
          </div>
          <div>
            <h4 className="font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-amber-400 transition">Home</Link></li>
              <li><a href="#dishes" className="text-gray-400 hover:text-amber-400 transition">Persian Dishes</a></li>
              <li><a href="#ordering" className="text-gray-400 hover:text-amber-400 transition">How to Order</a></li>
              <li><a href="#customs" className="text-gray-400 hover:text-amber-400 transition">Dining Customs</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4">Popular Dishes</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-amber-400 transition">Chelo Kabab</a></li>
              <li><a href="#" className="text-gray-400 hover:text-amber-400 transition">Fesenjan</a></li>
              <li><a href="#" className="text-gray-400 hover:text-amber-400 transition">Ghormeh Sabzi</a></li>
              <li><a href="#" className="text-gray-400 hover:text-amber-400 transition">Tahchin</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-gray-400 hover:text-amber-400 transition">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-gray-400 hover:text-amber-400 transition">Terms of Service</Link></li>
              <li><Link to="/cookies" className="text-gray-400 hover:text-amber-400 transition">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 mb-4 md:mb-0">© 2024 پیروز Pirooz. All rights reserved.</p>
          <div className="flex space-x-6">
            <a href="https://instagram.com/vajakapp" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-amber-400 transition"><FaInstagram className="text-xl" /></a>
            <a href="https://t.me/vajakapp" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-amber-400 transition"><FaTelegramPlane className="text-xl" /></a>
            <a href="https://wa.me/vajakapp" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-amber-400 transition"><FaWhatsapp className="text-xl" /></a>
          </div>
        </div>
      </div>
    </footer>
  </div>
);

export default FoodGuide; 